import dynamic from "next/dynamic";
import React from "react";

const Item = dynamic(import("./Item"));

const PopularCities = () => {
  return (
    <div className="w-full">
      <div className="border-b border-white">
        <h2 className="text-white">Popular Cities</h2>
      </div>
      <div className="text-white pt-2 flex flex-col gap-1">
        <Item
          search="/city/Mississauga"
          title="Bungalows for sale Mississauga Ontario"
        />
        <Item search="/city/Toronto" title="Bungalows for sale Toronto Ontario" />
        <Item search="/city/Brampton" title="Bungalows for sale Brampton Ontario" />
        <Item search="/city/Ajax" title="Bungalows for sale Ajax Ontario" />
        <Item search="/city/Burlington" title="Bungalows for sale Burlington Ontario" />
        <Item search="/city/Milton" title="Bungalows for sale Milton Ontario" />
        <Item search="/city/Hamilton" title="Bungalows for sale Hamilton Ontario" />
        <Item search="/city/Oakville" title="Bungalows for sale Oakville Ontario" />
        <Item search="/city/Caledon" title="Bungalows for sale Caledon Ontario" />
      </div>
    </div>
  );
};

export default PopularCities;
